import React, { type FC } from "react";

/** In RTL, "3 / 6" flips. Hebrew "מתוך" between the numbers does not. */
export const LtrNumberRatio: FC<{
  left: number | string;
  right: number | string;
  separator?: string;
}> = ({ left, right }) => (
  <>
    {left} מתוך {right}
  </>
);
